"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-ten/sections/headerSection.tsx */

import { LandingSiteTemplateGetDataMenuOutputApiModel } from "@/Apis/ClinicApi";
import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import HeaderNav from "../../Components/HeaderNav";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode, MouseEventHandler } from "react";

export type HomeTenHeaderSectionGeneratedProps = {
    menus: LandingSiteTemplateGetDataMenuOutputApiModel[];
    isScrolled?: boolean;
    onMobileBtn?: MouseEventHandler<HTMLAnchorElement>;
    onMenuClose?: MouseEventHandler<HTMLAnchorElement>;
    /** Default: "#" */
    headerDiv0Nav0Div0Link0LinkHref?: string;
    /** Default: "mobile_btn" */
    headerDiv0Nav0Div0Link0LinkId?: string;
    headerDiv0Nav0Div0Link0LinkVisible?: boolean;
    headerDiv0Nav0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.home10" */
    headerDiv0Nav0Div0Link1LinkHref?: string;
    headerDiv0Nav0Div0Link1LinkVisible?: boolean;
    headerDiv0Nav0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-white-02.svg" */
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc?: string;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible?: boolean;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Logo" */
    headerDiv0Nav0Div0Link1ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-10.svg" */
    headerDiv0Nav0Div0Link1ImageWithBasePath1ImageSrc?: string;
    headerDiv0Nav0Div0Link1ImageWithBasePath1ImageVisible?: boolean;
    headerDiv0Nav0Div0Link1ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link1ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "all_routes.home10" */
    headerDiv0Nav0Div1Div0Link0LinkHref?: string;
    headerDiv0Nav0Div1Div0Link0LinkVisible?: boolean;
    headerDiv0Nav0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-10.svg" */
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc?: string;
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible?: boolean;
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "#" */
    headerDiv0Nav0Div1Div0Link1LinkHref?: string;
    /** Default: "menu_close" */
    headerDiv0Nav0Div1Div0Link1LinkId?: string;
    headerDiv0Nav0Div1Div0Link1LinkVisible?: boolean;
    headerDiv0Nav0Div1Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.booking" */
    headerDiv0Nav0Ul0Li0Link0LinkHref?: string;
    headerDiv0Nav0Ul0Li0Link0LinkVisible?: boolean;
    headerDiv0Nav0Ul0Li0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Ul0Li0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Book Consultaion" */
    headerDiv0Nav0Ul0Li0Link0Span0SpanText?: ReactNode;
};

const HomeTenHeaderSectionGenerated: FC<HomeTenHeaderSectionGeneratedProps> = ({
    menus,
    isScrolled,
    onMobileBtn,
    onMenuClose,
    headerDiv0Nav0Div0Link0LinkHref = "#",
    headerDiv0Nav0Div0Link0LinkId = "mobile_btn",
    headerDiv0Nav0Div0Link0LinkVisible,
    headerDiv0Nav0Div0Link0LinkRenderer,
    headerDiv0Nav0Div0Link0LinkProps,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt = "Logo",
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-white-02.svg",
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps,
    headerDiv0Nav0Div0Link1ImageWithBasePath1ImageAlt = "Logo",
    headerDiv0Nav0Div0Link1ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/logo-10.svg",
    headerDiv0Nav0Div0Link1ImageWithBasePath1ImageVisible,
    headerDiv0Nav0Div0Link1ImageWithBasePath1ImageRenderer,
    headerDiv0Nav0Div0Link1ImageWithBasePath1ImageProps,
    headerDiv0Nav0Div0Link1LinkHref = "all_routes.home10",
    headerDiv0Nav0Div0Link1LinkVisible,
    headerDiv0Nav0Div0Link1LinkRenderer,
    headerDiv0Nav0Div0Link1LinkProps,
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt = "Logo",
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-10.svg",
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible,
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer,
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageProps,
    headerDiv0Nav0Div1Div0Link0LinkHref = "all_routes.home10",
    headerDiv0Nav0Div1Div0Link0LinkVisible,
    headerDiv0Nav0Div1Div0Link0LinkRenderer,
    headerDiv0Nav0Div1Div0Link0LinkProps,
    headerDiv0Nav0Div1Div0Link1LinkHref = "#",
    headerDiv0Nav0Div1Div0Link1LinkId = "menu_close",
    headerDiv0Nav0Div1Div0Link1LinkVisible,
    headerDiv0Nav0Div1Div0Link1LinkRenderer,
    headerDiv0Nav0Div1Div0Link1LinkProps,
    headerDiv0Nav0Ul0Li0Link0LinkHref = "all_routes.booking",
    headerDiv0Nav0Ul0Li0Link0LinkVisible,
    headerDiv0Nav0Ul0Li0Link0LinkRenderer,
    headerDiv0Nav0Ul0Li0Link0LinkProps,
    headerDiv0Nav0Ul0Li0Link0Span0SpanText = "Book Consultaion",
}) => {
    return (
        <header className={isScrolled ? "header header-ten home-menu-11 fixed pharmacy-header" : "header header-ten home-menu-11"}>
            <div className="container">
                <nav className="navbar navbar-expand-lg header-nav">
                    <div className="navbar-header">
                        {renderNode(headerDiv0Nav0Div0Link0LinkVisible, headerDiv0Nav0Div0Link0LinkRenderer, (
                            <SmartLink id={headerDiv0Nav0Div0Link0LinkId} href={headerDiv0Nav0Div0Link0LinkHref} onClick={onMobileBtn} {...(headerDiv0Nav0Div0Link0LinkProps ?? {})}>
                                <i className="fa-solid fa-bars" />
                            </SmartLink>
                        ))}
                        {renderNode(headerDiv0Nav0Div0Link1LinkVisible, headerDiv0Nav0Div0Link1LinkRenderer, (
                            <SmartLink href={headerDiv0Nav0Div0Link1LinkHref} className="navbar-brand logo" {...(headerDiv0Nav0Div0Link1LinkProps ?? {})}>
                                {renderNode(headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible, headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc} className="img-fluid white-logo" alt={headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt} {...(headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                {renderNode(headerDiv0Nav0Div0Link1ImageWithBasePath1ImageVisible, headerDiv0Nav0Div0Link1ImageWithBasePath1ImageRenderer, (
                                    <SmartImage src={headerDiv0Nav0Div0Link1ImageWithBasePath1ImageSrc} className="img-fluid normal-logo" alt={headerDiv0Nav0Div0Link1ImageWithBasePath1ImageAlt} {...(headerDiv0Nav0Div0Link1ImageWithBasePath1ImageProps ?? {})} />
                                ))}
                            </SmartLink>
                        ))}
                    </div>
                    <div className="main-menu-wrapper">
                        <div className="menu-header">
                            {renderNode(headerDiv0Nav0Div1Div0Link0LinkVisible, headerDiv0Nav0Div1Div0Link0LinkRenderer, (
                                <SmartLink href={headerDiv0Nav0Div1Div0Link0LinkHref} className="menu-logo" {...(headerDiv0Nav0Div1Div0Link0LinkProps ?? {})}>
                                    {renderNode(headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible, headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc} className="img-fluid" alt={headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt} {...(headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </SmartLink>
                            ))}
                            {renderNode(headerDiv0Nav0Div1Div0Link1LinkVisible, headerDiv0Nav0Div1Div0Link1LinkRenderer, (
                                <SmartLink id={headerDiv0Nav0Div1Div0Link1LinkId} className="menu-close" href={headerDiv0Nav0Div1Div0Link1LinkHref} onClick={onMenuClose} {...(headerDiv0Nav0Div1Div0Link1LinkProps ?? {})}>
                                    <i className="fas fa-times" />
                                </SmartLink>
                            ))}
                        </div>
                        <HeaderNav menus={menus} />
                    </div>
                    <ul className="nav header-navbar-rht">
                        <li>
                            {renderNode(headerDiv0Nav0Ul0Li0Link0LinkVisible, headerDiv0Nav0Ul0Li0Link0LinkRenderer, (
                                <SmartLink href={headerDiv0Nav0Ul0Li0Link0LinkHref} className="btn btn-secondary" {...(headerDiv0Nav0Ul0Li0Link0LinkProps ?? {})}>
                                    <i className="isax isax-calendar-edit" />
                                    <span>{headerDiv0Nav0Ul0Li0Link0Span0SpanText}</span>
                                </SmartLink>
                            ))}
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default HomeTenHeaderSectionGenerated;
